// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[td-width-30][data-v-3b093120] {\n  width: 30%;\n}\n[td-width-60][data-v-3b093120] {\n  width: 60%;\n}", ""]);
// Exports
module.exports = exports;
